:host {
  display: block;
  max-width: 100%;
  padding-right: calc(var(--spacer) * 2 - 2px);
  padding-top: var(--spacer);
}

.subtitle {
  .icon {
    font-size: var(--header-font-size-large);
  }

  gz-text,
  .icon {
    color: var(--chart-302-icon-buttons-titles);
  }
}

gz-single-select-complex[id='device-extra-details-selection'] {
  --dropdown-max-width: 100%;
  --dropdown-list-width: 100%;
  --dropdown-width: 100%;
}

gz-image-repo,
.device-details-container {
  max-height: calc(100% - 250px);
}

.scrollable {
  overflow-y: auto;
  overflow-x: hidden;
}

gz-labeled-content[class*='item-details'] {
  padding-top: 4px;

  &::part(content) {
    margin-top: -2px;
  }

  &::part(container) {
    padding-bottom: 0;
  }
}

.item-details-container {
  padding-bottom: 4px;
  min-width: 0;

  > * {
    height: 27px;
  }
}

gz-select[class*='side-menu-select'] {
  align-self: flex-start;
}

gz-text[class*='text-details'] {
  color: var(--body-text-arrows-400);
}
